import React, { useContext, useState } from "react";
import {
  InfoContainer,
  InfoWrapper,
  TextWrapper,
  TopLine,
  Heading,
  ImgWrap,
  SiginDescription,
  HeadingSub,
  SiginDescriptionSub,
} from "./InfoElements";
import Lottie from "lottie-react";
import IsometricHouse from "../../../../components/LottieAnimation/isometric-house.json";
import { LanguageContext } from "../../../../utils/language/Language";

const Info = () => {

  const [selectedLanguage, setSelectedLanguage] = useState(window.localStorage.getItem("rcml-lang") || "en");
  const { dictionary } = useContext(LanguageContext);
  return (
    <>
      <InfoContainer>
        <InfoWrapper>
              <ImgWrap>
              <div>
                <Lottie animationData={IsometricHouse} loop={true}/>
                </div>
              </ImgWrap>
              <TextWrapper>
                <TopLine>{dictionary.menzilString.find_it}</TopLine>
                <Heading>
                {dictionary.menzilString.smart_living}
                  {/* <HeadingSub>Smart People</HeadingSub> */}
                </Heading>
                {/* <SiginDescription>{dictionary.menzilString.much_did}</SiginDescription> */}
              </TextWrapper>
        </InfoWrapper>
      </InfoContainer>
    </>
  );
};

export default Info;
